export default (
  state = {
    sharedUsers: [],
    users: [],
    appView: null,
    sharedUser: null,
    metaView: null,
    viewData: null,
    recipientType: null,
    acceptingStates: null,
    senderAttachment: null,
    videoKyc: false,
    acceptRejectType: null,
    showAcceptRejectConfirmationPopup: false,
    docForwardingAllowed: false,
    docForwadingRecipientList: [],
    doc_object_id: "",
  },
  action,
) => {
  switch (action.type) {
    case "INIT_SHARED_DOCUMENT_DATA":
      return {
        ...state,
        appView: action.payload.app,
        sharedUser: action.payload.user,
        metaView: action.payload.meta,
        viewData: action.payload.child_view,
        recipientType: action.payload.recipient_type,
        acceptingStates: action.payload.accepting_states,
        senderAttachment: action.payload.sender_attachment,
        videoKyc: action.payload.video_kyc,
        docForwardingAllowed: action.payload.doc_forwarding_allowed,
        doc_object_id: action.payload.document
          ? action.payload.document.object_id
          : "",
        is_lz: action.payload.is_lz,
      };
    case "REMOVE_SHARED_DOCUMENT":
      return {
        ...state,
        sharedUsers: state.sharedUsers.filter(
          data => data.ShareHash !== action.payload,
        ),
      };

    case "SHARE_DOCUMENT_INIT_DATA": {
      const { users, sharedUsers } = action.payload;
      return {
        ...state,
        users,
        sharedUsers,
      };
    }

    case "DOCUMENT_SHARING_INFORMATION":
      return { ...state, sharedUsers: action.payload };

    case "UPDATE_DOCUMENT_SHARING_INFORMATION": {
      let newData = [];
      if (state.sharedUsers && state.sharedUsers.length > 0) {
        newData = [...action.payload, ...state.sharedUsers];
      } else {
        newData = action.payload;
      }
      return {
        ...state,
        sharedUsers: newData,
      };
    }

    case "UPDATE_DOCUMENT_RECIPIENT":
      return {
        ...state,
        recipientType: action.payload.recipientType,
      };

    case "RECIPIENT_DOC_ACCEPT_REJECT":
      return {
        ...state,
        acceptRejectType: action.payload.type,
        showAcceptRejectConfirmationPopup: action.payload.flag,
      };
    case "GET_SHARED_RECIPIENT_DOCUMENT":
      return {
        ...state,
        docForwadingRecipientList: action.payload,
      };
    default:
      return state;
  }
};
